module.exports = __webpack_public_path__ + "static/media/dots.d5ac7e20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dots.svg
// module id = 309
// module chunks = 0